import React from 'react';
import {
  Avatar,
  Colors,
  Flex,
  IconThumbsUpFill,
  IconThumbsUpRegular,
  Typography,
} from '@banhala/ui-kit';
import { EvaluationText } from 'shared/src/constant/domain/review/EvaluationText';
import { BestReviewChip } from './BestReviewChip';
import { DoublePointChip } from './DoublePointChip';
import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { formatDate } from 'shared/src/utils';
import { useToggleReviewLikeStatus } from '../../../hooks/useToggleReviewLikeStatus';

type ReviewerProfileProps = {
  review: GoodsReview;
};

export const ReviewerProfile: React.FC<ReviewerProfileProps> = ({ review }) => {
  const {
    member_profile_image_url,
    member_group,
    writer,
    created_at,
    eval: evaluation,
    is_best_review,
    is_double_point_review,
  } = review;
  const { value, action: onToggleReviewLike } =
    useToggleReviewLikeStatus(review);

  return (
    <Flex.Row justifyContent={'space-between'} alignItems={'center'}>
      <Flex.Row gap={8} alignItems={'center'}>
        <Avatar uri={member_profile_image_url} size={32} />
        <Flex gap={2}>
          <Flex.Row gap={4} alignItems={'center'}>
            <Typography type={'h5'} color={'content_primary'}>
              {EvaluationText[evaluation]}
            </Typography>

            <BestReviewChip visible={is_best_review} />
            <DoublePointChip visible={is_double_point_review} />
          </Flex.Row>
          <Flex.Row gap={4}>
            <Typography type={'body4'} color={'content_tertiary'}>
              {writer}
            </Typography>
            {member_group && (
              <Typography type={'subtitle4'} color={'content_tertiary'}>
                {member_group}
              </Typography>
            )}
            <Typography type={'body4'} color={'content_tertiary'}>
              {formatDate(created_at, 'YYYY.MM.DD')}
            </Typography>
          </Flex.Row>
        </Flex>
      </Flex.Row>
      <Flex
        alignItems={'center'}
        gap={4}
        padding={{ vertical: 0, horizontal: 6 }}
        onPress={onToggleReviewLike}
      >
        {value ? (
          <IconThumbsUpFill size={20} fill={Colors.content_blue_primary} />
        ) : (
          <IconThumbsUpRegular size={12} />
        )}
        <Typography type={'body4'} color={'content_tertiary'}>
          {review.review_likes_count}
        </Typography>
      </Flex>
    </Flex.Row>
  );
};
